import { service } from '@/utils/request'

export default {
	// 获取导航列表
	getAppNav() {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/list',
			method: 'get'
		})
	},
	// 获取导航详情
	getNavDetail(path) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/get/' + path,
			method: 'get'
		})
	},
	// 编辑
	modify(data) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/update',
			method: 'post',
			data: data
		})
	},
	// 删除
	deleteData(path) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/delete/' + path,
			method: 'post'
		})
	},
	// 添加
	addData(data) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/add',
			method: 'post',
			data: data
		})
	},
	// 排序
	sort(data) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/sort',
			method: 'post',
			data: data
		})
	},
	// 获取课程列表
	getCourseList(path,data) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/course/page/' + path,
			method: 'get',
			params: data
		})
	},
	// 添加课程
	addCourse(data) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/course/bind',
			method: 'post',
			data: data
		})
	},
	// 修改课程
	modifyData(data) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/course/update',
			method: 'post',
			data: data
		})
	},
	// 删除课程
	deleteCourse(path) {
	    return service({
			url: '/cloud/bbs/v1/navigation/admin/course/delete/' + path,
			method: 'post'
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/contentManage/appnav.js